import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
    {
        id: 1,
        label: 'MENUITEMS.MENU.TEXT',
        isTitle: true
    },
    {
        id: 2,
        label: 'MENUITEMS.DASHBOARDS.TEXT',
        icon: 'uil-home-alt',
        link: '/',
    },
    {
        id: 4,
        label: 'User Management',
        icon: 'uil-users-alt',
        subItems: [
            {
                id: 77,
                label: 'Add User',
                link: '/user-management/add-user',
                parentId: 4
            },
            {
                id: 78,
                label: 'All User',
                link: '/user-management/all-user',
                parentId: 4
            },
            {
                id: 79,
                label: 'Asign User',
                link: '/user-management/asign-user',
                parentId: 4  
            }
           
        ]
    },
    {
        id: 5,
        label: 'Buyer Management',
        icon: 'uil-box',
        subItems: [
            {
                id: 70,
                label: ' Add Buyer',
                link: '/buyer-management/add-buyer',
                parentId: 5
            },
            {
                id: 71,
                label: 'View Buyer',
                link: '/buyer-management/view-buyer',
                parentId: 5
            },
            
        ]
    },
    {
        id: 6,
        label: 'Pattern Management',
        icon: 'uil-bolt-alt',
        subItems: [
   
            {
                id: 78,
                label: 'View',
                link: '/pattern-management/all-patterns',
                parentId: 3
            },
            {
                id: 79,
                label: 'Add Size',
                link: '/pattern-management/add-size',
                parentId: 3
            },
            {
                id: 80,
                label: 'Add Positions',
                link: '/pattern-management/add-positions',
                parentId: 3
            }
           
        ]
    },
    {
        id: 8,
        label: 'Screen Printing',
        icon: 'uil-parcel',
        subItems: [
            {
                id: 100,
                label: 'Producion',
                parentId: 8,
                subItems: [
                    {
                        id: 101,
                        label: 'Add Sales Order',
                        link: '/sales-order/add-sales-order',
                        parentId: 100,
                    },
                    {
                        id: 101,
                        label: 'View All Sales Orders',
                        link: '/sales-order/view-sales-order',
                        parentId: 100,
                    },  
                    {
                        id: 102,
                        label: 'Add Gate Pass',
                        link: '/sales-order/add-gate-pass',
                        parentId: 8
                    },
                    {
                        id: 102,
                        label: 'View All Gate Passes',
                        link: '/sales-order/view-gate-pass',
                        parentId: 8
                    },
                    // {
                    //     id: 103,
                    //     label: 'Barcode Reader',
                    //     link: '/sales-order/barcode-reader',
                    //     parentId: 8
                    // },
                    {
                        id: 104,
                        label: 'Add Barcode Department',
                        link: '/sales-order/add-barcode-department',
                        parentId: 8
                    },
                    {
                        id: 105,
                        label: 'View Bundle Data',
                        link: '/sales-order/view-bundle-data',
                        parentId: 8
                    },
                    {
                        id: 106,
                        label: 'Employee Management',
                        link: '/sales-order/add-employee',
                        parentId: 8,
                    },
                ]
            },
            {
                id: 200,
                label: 'Dispatch',
                parentId: 8,
                subItems: [
                    {
                        id: 201,
                        label: 'Gate Passes',
                        link: '/sales-order/dispatch-gate-passes',
                        parentId: 200,
                    },
                    {
                        id: 202,
                        label: 'Invoices',
                        link: '/sales-order/dispatch-view-invoices',
                        parentId: 200,
                    },
                ]
            },
            {
                id: 300,
                label: 'View SP Buyers',
                link: '/sales-order/view-buyers',
                parentId: 8
            },
        ]
    },
    {
        id: 9,
        label: 'Orders',
        icon: 'uil-bolt-alt',
        subItems: [
            {
                id: 80,
                label: 'View Orders',
                link: '/orders/view-orders',
                parentId: 3
            },
            {
                id: 81,
                label: 'View Orders By Po',
                link: '/orders/view-orders-by-po',
                parentId: 4
            },
            {
                id:82,
                label: 'View Reports',
                link: '/orders/reports',
                parentId: 5                
            },
            {
                id:83,
                label: 'Invoice',
                link: '/orders/add-invoice',
                parentId: 5                
            }
        ]
    },
    {
        id: 10,
        label: 'System Admin',
        icon: 'uil-bolt-alt',
        subItems: [
            {
                id: 84,
                label: 'Client Names',
                link: '/master-tables/client-names',
                parentId: 3
            },
        ]
    },
];

